import React from 'react';
import styles from './categories.module.scss';
import { useSelector } from 'react-redux';
import { GlobalState } from 'src/logic/reducers';
import { routes } from 'src/routes';
import { DateString } from 'src/logic/utils';
import { slugifyName } from '../../../logic/utils/slug';
import { SectionInfo } from '../sectionInfo/sectionInfo';

const catImg = new Map<string,string>([
  ['kanapki','/images/categories/kanapki.png'],
  ['sałatki', '/images/categories/salatki.png'],
  ['obiady', '/images/categories/obiady.png'],
  ['zupy', '/images/categories/zupy.png'],
  ['desery', '/images/categories/desery.png'],
  ['przekąski', '/images/categories/przekaski.png'],
  ['napoje', '/images/categories/napoje.png'],
  ['śniadania', '/images/categories/sniadania.png'],
  ['sushi', '/images/categories/sushi2.png'],
  ['kawy', '/images/categories/kawy.png'],
  ['święta', '/images/categories/dla-dzieci.png'], // TODO
  ['dla dzieci', '/images/categories/dla-dzieci.png'],
  ['pomagamy', '/images/categories/pomagamy.png'],
  ['wielkanoc', '/images/categories/wielkanoc.png'],
  ['batony', '/images/categories/batony.png']]
);


const Category = ({ name, url, activeDate }: { name: string; url: string; activeDate: DateString }) => {
  return (
    <div className={styles.category}>
      <div>
        <img src={url} alt={name} />
      </div>
      <a href={`${routes.menu(new Date(activeDate))}#${slugifyName(name)}`}>{name}</a>
    </div>
  )
}

export const Categories = ({activeDate}: {activeDate: DateString}) => {
  const categories = useSelector((gs: GlobalState) => gs.menu.categories);
  const exclude = ['zestawy', 'polecane'];
  return (
    <>
      <SectionInfo top='Wybierz' bottom='coś dla siebie!' arrowLocation='left-left-down' textLocation='right' />
      <div className={styles.categoriesList}>
        {categories.map(c => exclude.includes(c.toLowerCase())? '': <Category key={c} name={c} activeDate={activeDate} url={catImg.get(c.toLowerCase())?? '/dinner.png'} />)}
      </div>
    </>
  )
}
